import { render, staticRenderFns } from "./VerifyList.vue?vue&type=template&id=6a4a8b8a&scoped=true"
import script from "./VerifyList.vue?vue&type=script&lang=js"
export * from "./VerifyList.vue?vue&type=script&lang=js"
import style0 from "./VerifyList.vue?vue&type=style&index=0&id=6a4a8b8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4a8b8a",
  null
  
)

export default component.exports